import { AppButton } from 'components';
import {
  AppModal,
  AppModalBody,
  AppModalFooter,
  AppModalHeader,
} from 'components/molecules/Modal/AppModal';
import useDeleteEST from 'hooks/API/DELETE/useDeleteEST';
import useToaster from 'hooks/useToaster';

function ESTDeleteModal({ modalConfig = {}, closeModal }) {
  const { mutate, isLoading, isError } = useDeleteEST();
  useToaster(isLoading, { type: isError ? 'error' : 'success' });

  function deleteEST() {
    mutate(modalConfig.data ?? {});
    closeModal();
  }

  return (
    <AppModal open={modalConfig.show} closeModal={closeModal} size="md">
      <AppModalHeader>Delete Region</AppModalHeader>
      <AppModalBody>
        <p className="modal-sub-text text-center">Are you sure you want to delete this region?</p>

        <div className="app-l-modal-btn-block">
          <AppButton variantClass="btn-plane p--tint mx-4" onClick={deleteEST}>
            YES<sup>*</sup>
          </AppButton>
          <AppButton variantClass="btn-plane p--tint mx-4" onClick={closeModal}>
            NO
          </AppButton>
        </div>

        <p className="modal-sub-note">
          <sup>*</sup>Please note that this action is irreversible
        </p>
      </AppModalBody>
    </AppModal>
  );
}

export default ESTDeleteModal;
